import React from 'react';

import { DateTime, IntervalObject } from 'luxon';

import DayColumn from './Column';
import { StyledDaysCalendarWrap } from './styled';

interface DaysCalendarProps {
	days: IntervalObject[];
	renderHour: (hour: number, date: IntervalObject) => React.ReactNode;
	maxHour?: number;
	minHour?: number;
	date?: string;
	dateTime?: DateTime;
}

function DaysCalendar({ days, date, dateTime, ...props }: DaysCalendarProps) {
	const selectedDate = date ? DateTime.fromISO(date) : dateTime;

	const filteredDays = days.filter((interval) => interval.start.hasSame(selectedDate, 'day'));

	return (
		<StyledDaysCalendarWrap>
			{filteredDays?.map((day) => (
				<DayColumn day={day} key={day.start.toISO()} {...props} />
			))}
		</StyledDaysCalendarWrap>
	);
}

export default DaysCalendar;
